

























import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { FormatMixin } from '@/mixins/FormatMixin';
import FeedbackTable from '@/views/pages/admin/FeedbackTable.vue';
import { IFeedback } from 'admiral-core';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { FeedbackApi } from '@/services/FeedbackApi';

@Component({
  name: 'feedback',
  components: {
    FeedbackTable,
  },
})
export default class Announcements extends mixins(FormatMixin, BaseMixin) {
  feedbacks: IFeedback[] = [];

  selectedFeedback: Partial<IFeedback> = {};

  async mounted() {
    await this.loadFeedbacks();
  }

  async loadFeedbacks() {
    const response = await FeedbackApi.getFeedbacks();
    this.feedbacks = response.data;
  }

  async reload() {
    await this.loadFeedbacks();
  }
}
